import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import Rain from "./../../../images/rainbow.gif";

//Import Components
import { ThemeContext } from "../../../context/ThemeContext";
import { IMAGES, SVGICON } from "../../constant/theme";
import { withRouter } from "../../../App";
import { connect, useDispatch } from "react-redux";
import { getCandidates } from "../../../store/actions/Candidates/candidateActions";
import { getCompanies } from "../../../store/actions/Companies/companyActions";
import { getAllJobs } from "../../../store/actions/Jobs/jobActions";
import ProjectOverviewTab from "./elements/ProjectOverviewTab";
import ToDoList from "./elements/ToDoList";
import ActiveProjects from "./elements/ActiveProjects";
import RunningSwiper from "./RunningSwiper";
import UpcomingBlog from "./elements/UpcomingBlog";
import AllProjectBlog from "./elements/AllProjectBlog";
import RevenueChart from "./elements/RevenueChart";
import { get } from "../../../services/api";

// const RevenueChart = loadable(() =>
//   pMinDelay(import("./elements/RevenueChart"), 1000)
// );
const ExpensesBarChart = loadable(() =>
  pMinDelay(import("./elements/ExpensesBarChart"), 1000)
);
const TotalDeposit = loadable(() =>
  pMinDelay(import("./elements/TotalDeposit"), 1000)
);
const MyProgressChart = loadable(() =>
  pMinDelay(import("./elements/MyProgressChart"), 1000)
);


const Home = ({token, candidates, companies, allJobs}) => {
  const dispatch = useDispatch();
  const [timesheets, settimesheets] = useState([]);
  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    dispatch(getCandidates(token));
    dispatch(getCompanies(token));
    dispatch(getAllJobs(token));
    getTimeSheet();
  }, []);

  const getTimeSheet = async() => {
    const data = await get('/api/timesheet/get',token);
    settimesheets(data.data);
  }

  const unAssignedCandidate = allJobs.map(a=> a.quantity - a.candidates).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  const totalJobQuantity = allJobs.map(a=> a.quantity).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  const totalunAssignedCandidate = allJobs.map(a=> a.quantity).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  const totalAssignedCandidates = allJobs.map(a=> a.candidates).reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  const candidatesseries = () => {
    const groupedByMonthYear = candidates.reduce((acc, obj) => {
      const regDate = new Date(obj.regDate);
      const key = `${regDate.getFullYear()}-${String(regDate.getMonth() + 1).padStart(2, "0")}`;
    
      if (!acc[key]) {
        acc[key] = { monthYear: key, count: 0, records: [] };
      }
    
      acc[key].count += 1;
      acc[key].records.push(obj);
    
      return acc;
    }, {});
    const result = Object.values(groupedByMonthYear);

    const res =  [
        {
            name: 'Registered',
            data: result.map(r=>r.count),	
        }, 
       
        
    ]
    return res;
  };

  const candidatesseries2 = () => {
    const groupedByMonthYear = candidates.reduce((acc, obj) => {
      //const regDate = new Date(obj.regDate);
      //const key = `${regDate.getFullYear()}-${String(regDate.getMonth() + 1).padStart(2, "0")}`;
      const key = obj.status;
      if (!acc[key]) {
        acc[key] = { key: key, count: 0, records: [] };
      }
    
      acc[key].count += 1;
      acc[key].records.push(obj);
    
      return acc;
    }, {});
    const result = Object.values(groupedByMonthYear);

    const res =  [
        {
            name: 'Count',
            data: result.map(r=>r.count),	
            keys: Object.keys(groupedByMonthYear)
        }, 
       
        
    ]
    
    return res;
  };

  const getProjectData = () => {
    const currentYear = new Date().getFullYear();
    const lastYear = currentYear - 1;

const initializeYearData = () => [
    { month: "Jan", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Feb", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Mar", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Apr", revenue: 0, quantity: 0, jobs: 0 },
    { month: "May", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Jun", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Jul", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Aug", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Sep", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Oct", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Nov", revenue: 0, quantity: 0, jobs: 0 },
    { month: "Dec", revenue: 0, quantity: 0, jobs: 0 }
];

const groupedData = {
    currentYear: initializeYearData(),
    lastYear: initializeYearData()
};

timesheets.forEach(timesheet => {
    const date = new Date(timesheet.jobDate);
    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'short' });

    if (year === currentYear || year === lastYear) {
        const targetKey = year === currentYear ? "currentYear" : "lastYear";

        const monthEntry = groupedData[targetKey].find(entry => entry.month === month);
        if (monthEntry) {
          const filtered = allJobs.filter(j => j._id === timesheet.jobId);
          let payRate = 0;
          if (filtered?.length > 0) {
            payRate = Number(filtered?.[0].payRates?.[0].chargeRate ?? 0);
          }
          monthEntry.revenue += timesheet.hours * payRate;
        }
    }
});

allJobs.forEach(timesheet => {
  console.log("timesheet", timesheet);
  const date = new Date(timesheet.jobStartDate);
  const year = date.getFullYear();
  const month = date.toLocaleString('default', { month: 'short' });

  if (year === currentYear || year === lastYear) {
      const targetKey = year === currentYear ? "currentYear" : "lastYear";

      const monthEntry = groupedData[targetKey].find(entry => entry.month === month);
      if (monthEntry) {
        
        monthEntry.quantity += timesheet.candidates;
        monthEntry.jobs += timesheet.quantity;
      }
  }
});

return groupedData;
  }

  const companysseries = () => {
    const groupedByMonthYear = companies.reduce((acc, obj) => {
      const regDate = new Date(obj.regDate);
      const key = `${regDate.getFullYear()}-${String(regDate.getMonth() + 1).padStart(2, "0")}`;
    
      if (!acc[key]) {
        acc[key] = { monthYear: key, count: 0, records: [] };
      }
    
      acc[key].count += 1;
      acc[key].records.push(obj);
    
      return acc;
    }, {});
    const result = Object.values(groupedByMonthYear);

    const res =  [
        {
            name: 'Registered',
            data: result.map(r=>r.count),	
        }, 
       
        
    ]
    return res;
  };

  const companysseries2 = () => {
    const groupedByMonthYear = companies.reduce((acc, obj) => {
      const key = obj.status;
      if (!acc[key]) {
        acc[key] = { key: key, count: 0, records: [] };
      }
    
      acc[key].count += 1;
      acc[key].records.push(obj);
    
      return acc;
    }, {});
    const result = Object.values(groupedByMonthYear);

    const res =  [
        {
            name: 'Count',
            data: result.map(r=>r.count),	
            keys: Object.keys(groupedByMonthYear)
        }, 
       
        
    ]
    return res;
  };

    

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-9 col-xxl-12">
            <div className="row">
              <div className="col-xl-12">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="row">
                      <div className="col-xl-6 col-sm-6">
                        <div className="card bg-primary text-white">
                          <div className="card-header border-0 flex-wrap">
                            <div className="revenue-date">
                              <span>Total Candidates</span>
                              <h4 className="text-white">
                                {candidates?.length}
                              </h4>
                            </div>
                            <div className="avatar-list avatar-list-stacked me-2">
                              <span className="avatar rounded-circle bg-white">
                                <Link to={"/candidates"}>
                                  {SVGICON.PlusSymbal}
                                </Link>
                              </span>
                            </div>
                          </div>
                          <div className="card-body pb-0 custome-tooltip d-flex align-items-center">
                            <RevenueChart series={candidatesseries2()} />
                            {/* <div>
                              {SVGICON.WhiteArrowUp}
                              <span className="d-block font-w600">45%</span>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="card bg-secondary text-white">
                          <div className="card-header border-0">
                            <div className="revenue-date">
                              <span className="text-black">
                                Total Companies
                              </span>
                              <h4 className="text-black">
                                {companies?.length}
                              </h4>
                            </div>
                            <div className="avatar-list avatar-list-stacked me-2">
                              <span className="avatar rounded-circle bg-white">
                                <Link to={"/companies"}>
                                  {SVGICON.PlusSymbal}
                                </Link>
                              </span>
                            </div>
                          </div>
                          <div className="card-body pb-0 custome-tooltip d-flex align-items-center">
                            <ExpensesBarChart series={companysseries2()} />
                            {/* <div>
                              {SVGICON.DarkArrowUp}
                              <span className="d-block font-w600 text-black">
                                45%
                              </span>
                            </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="card">
                          <div className="card-body depostit-card">
                            <div className="depostit-card-media d-flex justify-content-between style-1">
                              <div>
                                <h6>Unassigned Candidates On All Requirements</h6>
                                <h3>
                                  {totalJobQuantity -
                                    totalAssignedCandidates}
                                </h3>
                              </div>
                              <div className="icon-box bg-secondary">
                                {SVGICON.Shiled}
                              </div>
                            </div>
                            <div className="progress-box mt-0">
                              {/* <div className="d-flex justify-content-between">
                                <p className="mb-0">Requirement Fulfilment(Candidate Assigned / Total No. of Req. Qty)</p>
                                <p className="mb-0">
                                  {totalAssignedCandidates}/
                                  {totalJobQuantity}
                                </p>
                              </div> */}
                              <div className="progress">
                                <div
                                  className="progress-bar bg-secondary"
                                  style={{
                                    width: "50%",
                                    height: "5px",
                                    borderRadius: "4px",
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="card same-card">
                          <div className="card-body depostit-card p-0">
                            <div className="depostit-card-media d-flex justify-content-between pb-0">
                              <div>
                                <h6>Total Profit</h6>
                                <h3>
                                  £
                                  {timesheets
                                    ?.map((a) => {
                                      const filtered = allJobs.filter(
                                        (j) => j._id === a.jobId
                                      );
                                      let payRate = 0;
                                      let chargeRate = 0;
                                      if (filtered?.length > 0) {
                                        chargeRate = Number(
                                          filtered?.[0].payRates?.[0]
                                            .chargeRate ?? 0
                                        );
                                        payRate = Number(
                                          filtered?.[0].payRates?.[0].payRate ??
                                            0
                                        );
                                      }

                                      return (
                                        a.hours * chargeRate - a.hours * payRate
                                      );
                                    })
                                    .reduce(
                                      (accumulator, currentValue) =>
                                        accumulator + currentValue,
                                      0
                                    ).toFixed(2)}
                                </h3>
                              </div>
                              <div
                                className="icon-box bg-primary"
                                style={{ color: "white", fontWeight: "800" }}
                              >
                                £
                              </div>
                            </div>
                            <TotalDeposit />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-sm-6">
                    <div className="col-xl-12 col-sm-12">
                      <div className="card same-card">
                        <div className="card-body depostit-card p-0">
                          <div className="depostit-card-media d-flex justify-content-between pb-0">
                            <div>
                              <h6>Total Payouts</h6>
                              <h3>
                                £
                                {timesheets?.filter(itm => { if(itm.invoiceNo) { return true;}})
                                  ?.map((a) => {
                                    const filtered = allJobs.filter(
                                      (j) => j._id === a.jobId
                                    );
                                    let payRate = 0;
                                    if (filtered?.length > 0) {
                                      payRate = Number(
                                        filtered?.[0].payRates?.[0].payRate ?? 0
                                      );
                                    }

                                    return a.hours * payRate;
                                  })
                                  .reduce(
                                    (accumulator, currentValue) =>
                                      accumulator + currentValue,
                                    0
                                  ).toFixed(2)}
                              </h3>
                            </div>
                            <div
                              className="icon-box bg-primary"
                              style={{ color: "white", fontWeight: "800" }}
                            >
                              £
                            </div>
                          </div>
                          <TotalDeposit />
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12 col-sm-12">
                      <div className="card same-card">
                        <div className="card-body depostit-card p-0">
                          <div className="depostit-card-media d-flex justify-content-between pb-0">
                            <div>
                              <h6>Total Revenue</h6>
                              <h3>
                                £
                                {timesheets?.filter(itm => { if(itm.invoiceNo) { return true;}})
                                  ?.map((a) => {
                                    const filtered = allJobs.filter(
                                      (j) => j._id === a.jobId
                                    );
                                    let payRate = 0;
                                    if (filtered?.length > 0) {
                                      payRate = Number(
                                        filtered?.[0].payRates?.[0]
                                          .chargeRate ?? 0
                                      );
                                    }

                                    return a.hours * payRate;
                                  })
                                  .reduce(
                                    (accumulator, currentValue) =>
                                      accumulator + currentValue,
                                    0
                                  ).toFixed(2)}
                              </h3>
                            </div>
                            <div
                              className="icon-box bg-primary"
                              style={{ color: "white", fontWeight: "800" }}
                            >
                              £
                            </div>
                          </div>
                          <TotalDeposit />
                        </div>
                      </div>
                    </div>

                    {/* <div
                      className="card bg-success rainbow-box"
                      style={{
                        backgroundImage: "url(" + Rain + ")",
                        backgroundSize: "cover",
                        backgroundBlendMode: "luminosity",
                      }}
                    >
                      <div className="card-header border-0">
                        {SVGICON.WhiteLogo}
                      </div>
                      <div className="card-body pt-0">
                        <div className="finance">
                          <h4>Your Finances, safe and Secure</h4>
                          <p>
                            It is a long established fact that a reader will be
                            distracted by the readable content of a page when
                            looking at its layout.
                          </p>
                        </div>
                        <div className="d-flex pt-3">
                          <div className="avatar-list avatar-list-stacked">
                            <img
                              src={IMAGES.contact5}
                              className="avatar rounded-circle"
                              alt=""
                            />
                            <img
                              src={IMAGES.contact6}
                              className="avatar rounded-circle"
                              alt=""
                            />
                            <img
                              src={IMAGES.contact7}
                              className="avatar rounded-circle"
                              alt=""
                            />
                          </div>
                          <div className="ratting-data">
                            <h4>15k+</h4>
                            <span>Happy Clients</span>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="col-xl-3 col-sm-6">
                    <div className="card">
                      <div className="card-body">
                        <MyProgressChart
                          value={
                            totalAssignedCandidates > 0
                              ? (
                                  (totalAssignedCandidates /
                                    totalJobQuantity) *
                                  100
                                ).toFixed(2)
                              : 0
                          }
                        />
                        <span className="right-sign">{SVGICON.RightCheck}</span>
                        <div className="redia-date text-center">
                          <h4>My Progress</h4>
                          <p>Assigning Candidates to Job Requirements</p>
                          <Link
                            to={"/requirement-plans"}
                            className="btn btn-secondary text-black"
                          >
                            More Details
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-12">
                    <ProjectOverviewTab height={300} data={getProjectData()} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
	return {
	  loggedInUser: state.auth.auth.user,
    token: state.auth.auth.token,
    candidates: state.candidates.candidates || [],
    companies: state.companies.companies || [],
    allJobs: state.jobs.allJobList || [],
	};
  };
export default withRouter(connect(mapStateToProps)(Home));
